var render = function render(){var _vm=this,_c=_vm._self._c;return _c('title-wrapper',{attrs:{"title":_vm.$t('helpers.logIn')}},[_c('login-form',{on:{"emitUserData":_vm.setUserData}}),_c('statement-modal',{attrs:{"open":_vm.isModalOpen},on:{"close":_vm.close,"confirm":_vm.confirmAndLogin}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }